import { combineReducers } from 'redux';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action as IdealistDayEventsAction } from '../../actions/userDashboard/idealistDayEvents';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import idealistDayEvents from './idealistDayEvents';

const reducers = {
  idealistDayEvents,
};
export default combineReducers<typeof reducers, IdealistDayEventsAction>(
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ idealistDayEvents: (state: Sta... Remove this comment to see the full error message
  reducers
);
